import { formatDateFromDB } from '../../../../../../utils/FormatDate';
import classes from './ItemList.module.css';

const ItemList = ({ item, columns, titleName }) => {
  return (
    <li
      // key={item.materijal}
      className={classes.meetingItemWrapper}
      style={{ width: '500px' }}
    >
      <div
        className={classes.meetingFlag}
        style={{
          background: '#F4535F',
        }}
      />

      <div
        className={classes.meetingItem}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          alignItems: 'center',
        }}
      >
        <div>
          <p className={classes.meetingTitle}>{item[titleName]}</p>
          <p
            className={classes.meetingDescription}
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '45px',
            }}
          >
            {columns.map((colItem) => (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {console.log(item)}
                {console.log(colItem)}
                <span
                  style={{
                    fontWeight: 600,
                    color: '#464646',
                    fontSize: '16px',
                    textAlign: 'center',
                  }}
                >
                  {colItem.label}
                </span>

                <span
                  style={{
                    fontWeight: 600,
                    color: '#F4535F',
                    fontSize: '16px',
                    textAlign: 'center',
                  }}
                >
                  {item[colItem.fieldname]}
                </span>
              </div>
            ))}
          </p>
        </div>
      </div>
    </li>
  );
};

export default ItemList;
